// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

.codeActionMenuWidget {
	padding: 8px 0px 8px 0px;
	overflow: auto;
	font-size: 13px;
	border-radius: 5px;
	min-width: 160px;
	z-index: 40;
	display: block;
	/* flex-direction: column;
	flex: 0 1 auto; */
	width: 100%;
	border-width: 0px;
	border-color: none;
	background-color: var(--vscode-menu-background);
	color: var(--vscode-menu-foreground);
	box-shadow: rgb(0,0,0, 16%) 0px 2px 8px;
}

.codeActionMenuWidget .monaco-list:not(.element-focused):focus:before {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 5; /* make sure we are on top of the tree items */
	content: "";
	pointer-events: none; /* enable click through */
	outline: 0px solid !important; /* we still need to handle the empty tree or no focus item case */
	outline-width: 0px !important;
	outline-style: none !important;
	outline-offset: 0px !important;
}

.codeActionMenuWidget .monaco-list {
	user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
	border: none !important;
	border-width: 0px !important;
}

/* .codeActionMenuWidget .monaco-list:not(.element-focus) {
	border: none !important;
	border-width: 0px !important;
} */

.codeActionMenuWidget .monaco-list .monaco-scrollable-element .monaco-list-rows {
	height: 100% !important;
}

.codeActionMenuWidget .monaco-list .monaco-scrollable-element {
	overflow: visible;
}
/** Styles for each row in the list element **/

.codeActionMenuWidget .monaco-list .monaco-list-row:not(.separator) {
	display: flex;
	-mox-box-sizing: border-box;
	box-sizing: border-box;
	padding: 0px 26px 0px 26px;
	background-repeat: no-repeat;
	background-position: 2px 2px;
	white-space: nowrap;
	cursor: pointer;
	touch-action: none;
	width: 100%;
}


.codeActionMenuWidget .monaco-list .monaco-list-row:hover:not(.option-disabled),
.codeActionMenuWidget .monaco-list .moncao-list-row.focused:not(.option-disabled) {
	color: var(--vscode-menu-selectionForeground) !important;
	background-color: var(--vscode-menu-selectionBackground) !important;
}

.codeActionMenuWidget .monaco-list .option-disabled,
.codeActionMenuWidget .monaco-list .option-disabled .focused {
	pointer-events: none;
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	color: var(--vscode-disabledForeground) !important;
}

.codeActionMenuWidget .monaco-list .separator {
	border-bottom: 1px solid var(--vscode-menu-separatorBackground);
	padding-top: 0px !important;
	/* padding: 30px; */
	width: 100%;
	height: 0px !important;
	opacity: 1;
	font-size: inherit;
	margin: 5px 0 !important;
	border-radius: 0;
	display: flex;
	-mox-box-sizing: border-box;
	box-sizing: border-box;
	background-repeat: no-repeat;
	background-position: 2px 2px;
	white-space: nowrap;
	cursor: pointer;
	touch-action: none;
}
`, "",{"version":3,"sources":["webpack://./node_modules/monaco-editor/esm/vs/editor/contrib/codeAction/browser/media/action.css"],"names":[],"mappings":"AAAA;;;+FAG+F;;AAE/F;CACC,wBAAwB;CACxB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd;kBACiB;CACjB,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,+CAA+C;CAC/C,oCAAoC;CACpC,uCAAuC;AACxC;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,UAAU,EAAE,8CAA8C;CAC1D,WAAW;CACX,oBAAoB,EAAE,yBAAyB;CAC/C,6BAA6B,EAAE,iEAAiE;CAChG,6BAA6B;CAC7B,8BAA8B;CAC9B,8BAA8B;AAC/B;;AAEA;CACC,iBAAiB;CACjB,yBAAyB;CACzB,qBAAqB;CACrB,uBAAuB;CACvB,4BAA4B;AAC7B;;AAEA;;;GAGG;;AAEH;CACC,uBAAuB;AACxB;;AAEA;CACC,iBAAiB;AAClB;AACA,8CAA8C;;AAE9C;CACC,aAAa;CACb,2BAA2B;CAC3B,sBAAsB;CACtB,0BAA0B;CAC1B,4BAA4B;CAC5B,4BAA4B;CAC5B,mBAAmB;CACnB,eAAe;CACf,kBAAkB;CAClB,WAAW;AACZ;;;AAGA;;CAEC,wDAAwD;CACxD,mEAAmE;AACpE;;AAEA;;CAEC,oBAAoB;CACpB,2BAA2B;CAC3B,yBAAyB;CACzB,wBAAwB;CACxB,sBAAsB;CACtB,qBAAqB;CACrB,iBAAiB;CACjB,kDAAkD;AACnD;;AAEA;CACC,+DAA+D;CAC/D,2BAA2B;CAC3B,mBAAmB;CACnB,WAAW;CACX,sBAAsB;CACtB,UAAU;CACV,kBAAkB;CAClB,wBAAwB;CACxB,gBAAgB;CAChB,aAAa;CACb,2BAA2B;CAC3B,sBAAsB;CACtB,4BAA4B;CAC5B,4BAA4B;CAC5B,mBAAmB;CACnB,eAAe;CACf,kBAAkB;AACnB","sourcesContent":["/*---------------------------------------------------------------------------------------------\n *  Copyright (c) Microsoft Corporation. All rights reserved.\n *  Licensed under the MIT License. See License.txt in the project root for license information.\n *--------------------------------------------------------------------------------------------*/\n\n.codeActionMenuWidget {\n\tpadding: 8px 0px 8px 0px;\n\toverflow: auto;\n\tfont-size: 13px;\n\tborder-radius: 5px;\n\tmin-width: 160px;\n\tz-index: 40;\n\tdisplay: block;\n\t/* flex-direction: column;\n\tflex: 0 1 auto; */\n\twidth: 100%;\n\tborder-width: 0px;\n\tborder-color: none;\n\tbackground-color: var(--vscode-menu-background);\n\tcolor: var(--vscode-menu-foreground);\n\tbox-shadow: rgb(0,0,0, 16%) 0px 2px 8px;\n}\n\n.codeActionMenuWidget .monaco-list:not(.element-focused):focus:before {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tz-index: 5; /* make sure we are on top of the tree items */\n\tcontent: \"\";\n\tpointer-events: none; /* enable click through */\n\toutline: 0px solid !important; /* we still need to handle the empty tree or no focus item case */\n\toutline-width: 0px !important;\n\toutline-style: none !important;\n\toutline-offset: 0px !important;\n}\n\n.codeActionMenuWidget .monaco-list {\n\tuser-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tborder: none !important;\n\tborder-width: 0px !important;\n}\n\n/* .codeActionMenuWidget .monaco-list:not(.element-focus) {\n\tborder: none !important;\n\tborder-width: 0px !important;\n} */\n\n.codeActionMenuWidget .monaco-list .monaco-scrollable-element .monaco-list-rows {\n\theight: 100% !important;\n}\n\n.codeActionMenuWidget .monaco-list .monaco-scrollable-element {\n\toverflow: visible;\n}\n/** Styles for each row in the list element **/\n\n.codeActionMenuWidget .monaco-list .monaco-list-row:not(.separator) {\n\tdisplay: flex;\n\t-mox-box-sizing: border-box;\n\tbox-sizing: border-box;\n\tpadding: 0px 26px 0px 26px;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 2px 2px;\n\twhite-space: nowrap;\n\tcursor: pointer;\n\ttouch-action: none;\n\twidth: 100%;\n}\n\n\n.codeActionMenuWidget .monaco-list .monaco-list-row:hover:not(.option-disabled),\n.codeActionMenuWidget .monaco-list .moncao-list-row.focused:not(.option-disabled) {\n\tcolor: var(--vscode-menu-selectionForeground) !important;\n\tbackground-color: var(--vscode-menu-selectionBackground) !important;\n}\n\n.codeActionMenuWidget .monaco-list .option-disabled,\n.codeActionMenuWidget .monaco-list .option-disabled .focused {\n\tpointer-events: none;\n\t-webkit-touch-callout: none;\n\t-webkit-user-select: none;\n\t-khtml-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\tcolor: var(--vscode-disabledForeground) !important;\n}\n\n.codeActionMenuWidget .monaco-list .separator {\n\tborder-bottom: 1px solid var(--vscode-menu-separatorBackground);\n\tpadding-top: 0px !important;\n\t/* padding: 30px; */\n\twidth: 100%;\n\theight: 0px !important;\n\topacity: 1;\n\tfont-size: inherit;\n\tmargin: 5px 0 !important;\n\tborder-radius: 0;\n\tdisplay: flex;\n\t-mox-box-sizing: border-box;\n\tbox-sizing: border-box;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 2px 2px;\n\twhite-space: nowrap;\n\tcursor: pointer;\n\ttouch-action: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
